import { PagePending } from "@/components/ui/PagePending";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/supplier/$supplierId/sales")({
  pendingComponent: PagePending,
  beforeLoad: () => ({
    breadcrumb: "Sales",
  }),
});
